import { Component, OnInit } from '@angular/core';
import { default as data } from './../../../../src/assets/version.json'
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent  implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  
  public getVersion(): string {
    return this.getEnv() + '-' + data.version;
  }

  public getHash(): string {
    return data.githash;
  }

  public getDatetime(): string {
    return data.datetime;
  }

  public getEnv(): string {
    return environment.splunk.environment;
  }

}
